import type { Category } from '@wix/ambassador-funnel-intro-v1-intro-data/types'

export const defaultCategory: Required<Category> = {
  displayName: 'Local Business',
  industryId: '9e0d43c23f82998a6ac269b5',
  structureId: 'e51e11f3597e0c565deb792f',
  businessTermId: '38194ba8-1218-431c-a007-09c26c75ee0d',
  businessSegmentId: 'not-classified',
  postRegVertical: 'other',
  isDefault: true,
}
